import React from 'react';
import { ReactComponent as Icon } from '../assets/images/twitter.svg';

export default function TwitterIcon(props) {
  const { color, size } = props;
  return <Icon {...props} style={{fill: color ? color : '#e4e4e7'}} height={size} width={size} />
}
